/**
 * @generated SignedSource<<c6bb5fa6e478f4c6a8ce3a6d5efb67ff>>
 * @relayHash d648a72227e17e3ccc98e7fd2c57afbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0

import type { ConcreteRequest } from 'relay-runtime';
export type entitlementPickerQuery$variables = {
  accountId: string;
  cloudId: string;
};
export type entitlementPickerQuery$data = {
  readonly customerService: {
    readonly individualByAccountId: {
      readonly __typename: "CustomerServiceIndividual";
      readonly entitlementList: ReadonlyArray<{
        readonly id: string;
        readonly product: {
          readonly name: string;
        };
      }>;
      readonly id: string;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type entitlementPickerQuery = {
  response: entitlementPickerQuery$data;
  variables: entitlementPickerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ],
  "type": "QueryError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "entitlementPickerQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v2/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "individualByAccountId",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v5/*: any*/),
                        "action": "THROW"
                      },
                      {
                        "kind": "RequiredField",
                        "field": {
                          "concreteType": "CustomerServiceEntitlement",
                          "kind": "LinkedField",
                          "name": "entitlementList",
                          "plural": true,
                          "selections": [
                            (v5/*: any*/),
                            {
                              "concreteType": "CustomerServiceProduct",
                              "kind": "LinkedField",
                              "name": "product",
                              "plural": false,
                              "selections": [
                                (v6/*: any*/)
                              ]
                            }
                          ]
                        },
                        "action": "THROW"
                      }
                    ],
                    "type": "CustomerServiceIndividual"
                  },
                  (v7/*: any*/)
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "entitlementPickerQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "individualByAccountId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/),
                  {
                    "concreteType": "CustomerServiceEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlementList",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "concreteType": "CustomerServiceProduct",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "CustomerServiceIndividual"
              },
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0",
    "metadata": {},
    "name": "entitlementPickerQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "baacf070b69f09d660710a825f4cc406";

export default node;
